//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "hub-notification-compose",

	props: {

		namespace: {
			required: true,
			type: String
		}

	},

	data()
	{
		return {
			__mock: {
				device: {}
			},
			abortController: null,
			uniqueId: Latte.api.id(),
			isCalculatingDelay: false,
			isCalculatingRange: true,
			isLoading: false,
			isValidJson: true,
			fields: {
				type: "default",
				title: "",
				body: "",
				audience: "everyone",
				audienceChannel: "",
				audienceGeofence: 0,
				audienceDeviceToken: "",
				operatingSystem: "all",
				minVersion: "1.0.0",
				schedule: new Date()
			},
			lastType: "default",
			notices: [],
			rangeResponse: undefined,
			testResponse: undefined,
			geofences: []
		};
	},

	mounted()
	{
		Latte.action.on("hub:notifications:compose", data => this.open(Object.assign(data, {type: "default"})));
		Latte.action.on("hub:notifications:compose:data", data => this.open(Object.assign(data, {type: "data"})));
	},

	computed: {

		canSubmit()
		{
			if (this.isLoading)
				return false;

			if (this.fields.type === "data" && !this.isValidJson)
				return false;

			if (this.fields.type === "data" && this.fields.body.substr(0, 1) !== "{")
				return false;

			if (this.fields.type === "default" && this.fields.title.trim().length < 3)
				return false;

			if (this.fields.type === "default" && this.fields.body.trim().length < 3)
				return false;

			if (this.fields.audience === "channel" && this.fields.audienceChannel.trim() === "")
				return false;

			if (this.fields.audience === "geofence" && this.fields.audienceGeofence === 0)
				return false;

			if (this.fields.audience === "single-device" && this.fields.audienceDeviceToken.trim().length !== 36)
				return false;

			return true;
		},

		isScheduledInPast()
		{
			return Date.now() >= this.fields.schedule.getTime();
		}

	},

	methods: {

		close()
		{
			this.reset();
			Latte.ui.overlay.close(this.uniqueId);
		},

		open(data = {})
		{
			this.reset();
			Latte.ui.overlay.open(this.uniqueId);

			if (data.type)
				this.fields.type = data.type;

			if (this.geofences.length === 0)
				this.loadGeofences();

			if (data.geofenceId)
			{
				this.fields.audience = "geofence";
				this.fields.audienceGeofence = data.geofenceId;
			}

			if (data.deviceToken)
			{
				this.fields.audience = "single-device";
				this.fields.audienceDeviceToken = data.deviceToken;
			}

			if (data.notificationId)
			{
				Latte.api.request(`/api/hub/apps/${this.namespace}/notifications/${data.notificationId}`)
					.then(r => r.json())
					.then(r =>
					{
						this.fields = {
							type: "default",
							title: r.data.title,
							body: r.data.body,
							audience: r.data.audience,
							audienceChannel: r.data.channel,
							audienceGeofence: r.data.geofence_id,
							audienceDeviceToken: r.data.device_token,
							operatingSystem: r.data.os,
							minVersion: "1.0.0",
							schedule: new Date()
						};

						this.lastType = this.fields.type;

						this.loadRangeCalculation();
					})
					.catch(err => Latte.core.handleError(err));
			}

			this.loadRangeCalculation();
		},

		reset()
		{
			this.fields = {
				type: "default",
				title: "",
				body: "",
				audience: "everyone",
				audienceChannel: "",
				audienceGeofence: 0,
				audienceDeviceToken: "",
				operatingSystem: "all",
				minVersion: "1.0.0",
				schedule: new Date()
			};
			this.lastType = this.fields.type;
			this.rangeResponse = undefined;
			this.testResponse = undefined;
		},

		request(url, response)
		{
			this.isLoading = true;
			this.notices = [];

			const body = JSON.stringify({
				type: this.fields.type,
				title: this.fields.title,
				body: this.fields.body,
				audience: this.fields.audience,
				audienceDeviceToken: this.fields.audienceDeviceToken,
				audienceChannel: this.fields.audienceChannel,
				audienceGeofence: this.fields.audienceGeofence,
				minVersion: this.fields.minVersion,
				operatingSystem: this.fields.operatingSystem,
				schedule: Math.floor(this.fields.schedule.getTime() / 1000)
			});
			const cache = "no-cache";
			const method = "POST";

			Latte.api.request(url, {body, cache, method})
				.then(r => r.json())
				.then(r => response(r))
				.catch(err => Latte.core.handleError(err, () => this.isLoading = false));
		},

		submit()
		{
			const title = Latte.i18n.translate("hub-notifications", "Add notification?");
			const message = Latte.i18n.translate("hub-notifications", "If your notification is planned to be send in the next 5 minutes, there is no way to cancel it. Do you want to continue?");

			Latte.ui.message.confirm(title, message).then(result =>
			{
				if (result.button !== Latte.ui.message.Buttons.OK)
					return;

				this.request(`/api/hub/apps/${this.namespace}/notifications/enqueue`, r => this.onSubmitResponse(r));
			});
		},

		test()
		{
			const title = Latte.i18n.translate("hub-notifications", "Run test?");
			const message = Latte.i18n.translate("hub-notifications", "Performing a test will take some time because our notification servers will check if the notification can be delivered to every device that matches the audience requirements.");

			Latte.ui.message.confirm(title, message).then(result =>
			{
				if (result.button !== Latte.ui.message.Buttons.OK)
					return;

				this.request(`/api/hub/apps/${this.namespace}/notifications/test`, r => this.onTestResponse(r));
			});
		},

		loadGeofences()
		{
			this.isLoading = true;

			Latte.api.request(`/api/hub/apps/${this.namespace}/geofences?limit=1024`, {cache: "no-cache"})
				.then(r => r.json())
				.then(r => this.onGeofencesLoaded(r))
				.catch(err => Latte.core.handleError(err));
		},

		loadRangeCalculation()
		{
			if (this.abortController !== null)
				this.abortController.abort();

			this.rangeResponse = {
				"30days_active_percentage": 0,
				"90days_active_percentage": 0,
				os: {
					android: 0,
					ios: 0
				},
				total: 0
			};

			if (this.fields.audience === "channel" && this.fields.audienceChannel.trim() === "")
				return;

			if (this.fields.audience === "geofence" && this.fields.audienceGeofence === 0)
				return;

			if (this.fields.audience === "single-device" && this.fields.audienceDeviceToken.trim() === "")
				return;

			this.abortController = new AbortController();
			this.isCalculatingRange = true;

			Latte.api.request(`/api/hub/apps/${this.namespace}/notifications/calculate-range?audience=${this.fields.audience}&channel=${this.fields.audienceChannel}&geofenceId=${this.fields.audienceGeofence}&guid=${this.fields.audienceDeviceToken}&os=${this.fields.operatingSystem}&version=${this.fields.minVersion}`, {signal: this.abortController.signal})
				.then(r => r.json())
				.then(r => this.onReceivedRangeCalculation(r))
				.catch(() =>
				{
					// Nothing to do, we expect this to fail when the request is aborted.
				});
		},

		onGeofencesLoaded(response)
		{
			this.geofences = response.data;
			this.isLoading = false;
		},

		onReceivedRangeCalculation(response)
		{
			this.abortController = null;
			this.isCalculatingRange = false;
			this.rangeResponse = response.data || this.rangeResponse;
		},

		onSubmitResponse(response)
		{
			this.isLoading = false;
			console.log("onSubmitResponse", response);

			if (Latte.ui.notice.areEntitiesNotices(response.data))
				return this.notices = response.data;

			Latte.ui.snackbar.create({
				location: Latte.ui.snackbar.Locations.TOP,
				message: Latte.i18n.translate("hub-notifications", this.isScheduledInPast ? "Notification will be sent within a few seconds!" : "Notification is successfully scheduled!")
			});

			Latte.action.dispatch("data-tables:refresh");
			this.close();
		},

		onTestResponse(response)
		{
			this.isLoading = false;

			if (response.data.result.name)
			{
				this.notices = [
					{type: "success", message: Latte.i18n.translate("hub-notifications", "Notification successfully processed by our notification servers.")}
				];
			}
			else
			{
				this.notices = [
					{type: "error", message: `<pre class="m-0" style="white-space: pre-wrap">${JSON.stringify(response.data.result.error)}</pre>`}
				];
			}
		},

		percentage(p)
		{
			return (p * 100).toFixed(2);
		}

	},

	watch: {

		fields: {
			deep: true,
			immediate: true,
			handler(val)
			{
				if (val.type === "data" && val.body.length > 0)
					this.isValidJson = Latte.util.json.isJson(val.body);
				else
					this.isValidJson = true; // Always true for default notifications.

				if (val.type === this.lastType)
					return;

				this.lastType = val.type;
				this.fields.title = "";
				this.fields.body = "";
			}
		}

	}

}

